<div [id]="idModal" aria-hidden="true" class="popup-solicitudes-modal">
  <div tabindex="-1" data-micromodal-close class="popup-modal-overlay">
    <div
      role="dialog"
      aria-modal="true"
      class="popup-modal-container"
    >
      <button
        aria-label="Cerrar modal"
        (click)="cerrarModal()"
        class="popup-modal-close"
        type="button"
      >
        <em class="material-icons">close</em>
      </button>

      <div class="popup-modal-content">
        <div class="popup-modal-icon">
          <em class="material-icons">priority_high</em>
        </div>

        <p class="popup-modal-message">{{ textDescription }}</p>

        <button 
          (click)="irASolicitudesClick()"
          class="popup-modal-btn">
          Ir a mis solicitudes
        </button>
      </div>
    </div>
  </div>
</div>